import { useState, useEffect } from 'react';
import axios from 'axios';
import { Phone } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ConnectionItem = ({ connection, userId, isSelected, onClick, token, onCall, isPremium = false }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(`${API}/users/${userId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setUser(response.data);
      } catch (error) {
        console.error('Failed to load user');
      }
    };
    fetchUser();
  }, [userId, token]);

  if (!user) return null;

  return (
    <div
      data-testid={`connection-item-${userId}`}
      className={`p-4 cursor-pointer transition-colors border-b border-gray-100 ${
        isSelected ? 'bg-coral/10' : 'hover:bg-gray-50'
      }`}
    >
      <div className="flex items-center space-x-3">
        <Avatar className="border-2 border-teal" onClick={onClick}>
          <AvatarImage src={user.profile_photo} />
          <AvatarFallback className="bg-white text-black font-bold">
            {user.name.charAt(0)}
          </AvatarFallback>
        </Avatar>
        <div className="flex-1 min-w-0" onClick={onClick}>
          <h4 className="font-semibold truncate">{user.name}</h4>
          <p className="text-sm text-gray-500 truncate">Click to chat</p>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            if (!isPremium) return;
            if (onCall) onCall(user);
          }}
          className={`p-2 rounded-full transition-colors ${isPremium ? 'hover:bg-coral hover:text-white text-gray-500' : 'text-gray-300 cursor-not-allowed'}`}
          title={isPremium ? 'Call' : 'Premium only'}
        >
          <Phone className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
